import { useCallback, useState } from "react";
import { useAppSelector } from "./useAppSelector";

/**
 * Custom hook for handling and managing game filter options.
 *
 * This hook:
 * - Retrieves game data from the Redux store
 * - Maps the raw game data into filter-ready option objects (with ID and Name)
 * - Maintains a local state for filtered game data
 * - Provides a handler function to update filtered data only if it has changed
 *
 */

export const useGamesFilter = () => {
  const gamesFilter = useAppSelector((state) => state.gamesFilter.Items);
  const gamesFilterOptions = gamesFilter.map((game) => ({
    ID: game.Value,
    Name: game.Text,
  }));
  const [filteredData, setFilteredData] = useState(gamesFilterOptions);

  const handleFilteredData = useCallback(
    (filtered: typeof gamesFilterOptions) => {
      setFilteredData((prev) => {
        const isSame = JSON.stringify(prev) === JSON.stringify(filtered);
        if (isSame) return prev;
        return filtered;
      });
    },
    []
  );
  
  return {
    filteredData,
    handleFilteredData,
    gamesFilterOptions,
  };
};

export enum Games {
  GAMES = "Games",
}
